/* HAU-415: Klaviyo identified-visitor capture — exit-intent, cart pre-checkout, login incentive */
(function () {
  'use strict';

  var COMPANY = 'WShDMZ';
  var LIST_ID = 'Vd7gPM';
  var DISMISS_COOKIE = 'hg_ei_dismissed';

  function setCookie(name, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function hasCookie(name) {
    return document.cookie.split(';').some(function (c) {
      return c.trim().indexOf(name + '=') === 0;
    });
  }

  function subscribeEmail(email, source, onSuccess, onError) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          custom_source: source
        },
        relationships: {
          list: { data: { type: 'list', id: LIST_ID } }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-06-15'
      },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email }]);
      }
      onSuccess && onSuccess();
    }).catch(function () {
      onError && onError();
    });
  }

  /* ── 1. CART PRE-CHECKOUT CAPTURE ─────────────────────────────── */
  function initCartCapture() {
    var input = document.getElementById('hg-cart-email-input');
    if (!input) return;

    var saved = sessionStorage.getItem('hg_captured_email');
    if (saved) input.value = saved;

    input.addEventListener('blur', function () {
      var email = input.value.trim();
      if (!email || !email.includes('@')) return;
      sessionStorage.setItem('hg_captured_email', email);
      subscribeEmail(email, 'cart-pre-checkout', null, null);
    });
  }

  /* ── 2. EXIT-INTENT POPUP ─────────────────────────────────────── */
  function initExitIntent() {
    var popup = document.getElementById('hg-exit-popup');
    var overlay = document.getElementById('hg-exit-overlay');
    if (!popup || !overlay) return;
    if (hasCookie(DISMISS_COOKIE)) return;

    var form = document.getElementById('hg-exit-form');
    var emailInput = form ? form.querySelector('input[type="email"]') : null;
    var successEl = document.getElementById('hg-exit-success');
    var triggered = false;

    function showPopup() {
      if (triggered) return;
      triggered = true;
      overlay.style.display = 'block';
      popup.style.display = 'flex';
    }

    function hidePopup() {
      overlay.style.display = 'none';
      popup.style.display = 'none';
      setCookie(DISMISS_COOKIE, 7);
    }

    document.addEventListener('mouseleave', function (e) {
      if (e.clientY < 5) showPopup();
    });

    if (window.location.pathname === '/cart') {
      setTimeout(function () { showPopup(); }, 50000);
    }

    overlay.addEventListener('click', hidePopup);
    var closeBtn = document.getElementById('hg-exit-close');
    closeBtn && closeBtn.addEventListener('click', hidePopup);
    var skipBtn = document.getElementById('hg-exit-skip');
    skipBtn && skipBtn.addEventListener('click', hidePopup);

    form && form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email || !email.includes('@')) return;
      subscribeEmail(email, 'exit-intent', function () {
        sessionStorage.setItem('hg_captured_email', email);
        if (successEl) { form.style.display = 'none'; successEl.style.display = 'block'; }
        setCookie(DISMISS_COOKIE, 30);
        setTimeout(hidePopup, 2500);
      }, hidePopup);
    });
  }

  /* ── 3. LOGIN PAGE INCENTIVE ──────────────────────────────────── */
  function initLoginIncentive() {
    var loginPage = document.querySelector('.customer.login');
    if (!loginPage) return;
    if (loginPage.querySelector('#hg-login-incentive')) return;
    var banner = document.createElement('div');
    banner.id = 'hg-login-incentive';
    banner.style.cssText = [
      'background:#f8f4ef',
      'border:1px solid #e8ddd0',
      'border-radius:6px',
      'padding:12px 16px',
      'margin-bottom:24px',
      'font-size:14px',
      'color:#4a3728',
      'line-height:1.5'
    ].join(';');
    banner.textContent = 'Log in to access your saved cart anytime.';
    var anchor = loginPage.querySelector('h1#login');
    if (anchor) {
      anchor.insertAdjacentElement('afterend', banner);
    } else {
      loginPage.insertAdjacentElement('afterbegin', banner);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartCapture();
    initExitIntent();
    initLoginIncentive();
  });
}());
